
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  scrollTo(top: number) {
    this.document.scrollingElement.scrollTo({ top, behavior: 'smooth' });
  }
}
